import React from 'react';
import styles from './SegmentedControl.module.css';

export default ({ options, value, onClick, className = null }) => (
  <div className={`${styles.container} ${className}`}>
    <div className={styles.optionsContainer}>
      {options.map((opt, i) => (
        <div
          key={`segmented-control-${i.toString()}`}
          className={`${styles.option} ${
            value === opt.value ? styles.selected : null
          }`}
          role="presentation"
          onClick={() => onClick(opt)}
        >
          {opt.label}
        </div>
      ))}
    </div>
  </div>
);
